"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const NavigationWrapperWeb_1 = __importDefault(require("../common/NavigationWrapperWeb"));
const TabManagerWeb_1 = __importDefault(require("../common/TabManagerWeb"));
const react_1 = require("react");
const userHandlers_1 = require("../../handlers/userHandlers");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const PilotPassengerToggleWeb_1 = __importDefault(require("../common/PilotPassengerToggleWeb"));
const MyFlightsListWeb_1 = __importDefault(require("./MyFlightsListWeb"));
const native_1 = require("@react-navigation/native");
const flightHandlers_1 = require("../../handlers/flightHandlers");
const react_i18next_1 = require("react-i18next");
const myFlightsHelper_1 = require("../../services/myFlightsHelper");
const MyFightsWeb = () => {
    const asAPilot = (0, react_redux_1.useSelector)(selectors_1.getAsAPilot);
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        (0, userHandlers_1.getUserDetailsHandler)();
        (0, flightHandlers_1.getMyFlightsHandler)(asAPilot);
        (0, flightHandlers_1.getMyOffersHandler)(asAPilot);
    }, [asAPilot]));
    const [activeTab, setTab] = (0, react_1.useState)("all");
    const userDetails = (0, react_redux_1.useSelector)(selectors_1.getUser);
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    return ((0, jsx_runtime_1.jsx)(NavigationWrapperWeb_1.default, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "title", children: t('landing_page.navigation.flights') }), userDetails?.is_pilot && (0, jsx_runtime_1.jsx)(PilotPassengerToggleWeb_1.default, {}), (0, jsx_runtime_1.jsx)(TabManagerWeb_1.default, { setTab: setTab, tabs: (0, myFlightsHelper_1.getMyFlightsTabs)(t), activeTab: activeTab }), (0, jsx_runtime_1.jsx)(MyFlightsListWeb_1.default, { activeTab: activeTab, asAPilot: asAPilot, userDetails: userDetails })] }) }));
};
exports.default = MyFightsWeb;
